import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const BoxItem = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1rem',
  flex: 'none',
  order: 1,
  flexGrow: 1,
}));

const GenUnitCard = ({
  order,
  children,
  image,
  showStockAndWoNumber = true,
}) => {
  const { t } = useTranslation('global');
  const theme = useTheme();
  const isMediumSizeBreakPoint = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box display="flex" p={{ xs: 0, sm: 0 }}>
      {!isMediumSizeBreakPoint && (
        <Box
          display="flex"
          flexGrow={2}
          flexDirection="row"
          alignItems="flex-start"
        >
          <img
            component="img"
            style={{ width: '151px', height: 'auto', marginRight: '1rem' }}
            src={image}
            alt="Car reference"
          />
          <BoxItem>
            <Box>
              <Typography variant="subtitle2">{t('make')}:</Typography>
              <Typography variant="body1">{order?.vehicle?.make}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2">{t('model')}:</Typography>
              <Typography variant="body1">{order?.vehicle?.model}</Typography>
            </Box>
          </BoxItem>
          <BoxItem>
            <Box>
              <Typography variant="subtitle2">{t('year')}:</Typography>
              <Typography variant="body1">{order?.vehicle?.year}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2">{t('color')}:</Typography>
              <Typography variant="body1">
                {order?.vehicle?.color || '-'}
              </Typography>
            </Box>
          </BoxItem>
          <BoxItem>
            <Box>
              <Typography variant="subtitle2">{t('ro')}:</Typography>
              <Typography variant="body1">{order?.ro || '-'}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2">{t('po')}:</Typography>
              <Typography variant="body1">{order?.po || '-'}</Typography>
            </Box>
          </BoxItem>
          {showStockAndWoNumber && (
            <BoxItem>
              <Box>
                <Typography variant="subtitle2">{t('stock')}:</Typography>
                <Typography variant="body1">{order?.stockNumber}</Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2">{t('wo')}:</Typography>
                <Typography variant="body1">{order?.woNumber}</Typography>
              </Box>
            </BoxItem>
          )}
        </Box>
      )}
      {children && (
        <Box flexGrow={1} display={{ sm: 'block', md: 'flex' }} gap={3}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default GenUnitCard;
